import React from "react";
import TooltipIconList, {
  TooltipIconListItem,
} from "components/shared/TooltipIconList";

interface Logo {
  name: string;
  iconifyClass?: string;
  skillName?: string;
}

interface ProjectLanguagesProps {
  logos: Logo[];
}

const ProjectLanguages: React.FC<ProjectLanguagesProps> = (props) => {
  const items: TooltipIconListItem[] = (props.logos ?? []).map(
    (logo, index) => ({
      id: `${logo.name}-${index}`,
      icon: logo.iconifyClass ?? "",
      tooltip: logo.name,
      dataName: logo.skillName,
    }),
  );

  return <TooltipIconList items={items} />;
};

export default ProjectLanguages;
